import { render, staticRenderFns } from "./information-autorisation.vue?vue&type=template&id=d64adb7a&scoped=true&"
import script from "./information-autorisation.vue?vue&type=script&lang=ts&"
export * from "./information-autorisation.vue?vue&type=script&lang=ts&"
import style0 from "./information-autorisation.vue?vue&type=style&index=0&id=d64adb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64adb7a",
  null
  
)

export default component.exports